module.exports = __webpack_public_path__ + "img/success.a998d995.png";